import React, { useContext, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Badge,
} from "react-bootstrap";
import { FaArrowLeft, FaStar, FaRegStar, FaCamera } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../../assets/css/user/orderrating/orderrating.css";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../general/SimpleBanner";
import Footer from "../footer/Footer";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";

const CustomerRating = () => {
  const navigate = useNavigate();
  const { shopId,orderId } = useParams(); // shop id
  const { baseUrl } = useContext(AppContext);
  const [order, setOrder] = useState();

  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");

const handleSubmit = () => {
  const savedCustomer = JSON.parse(
    localStorage.getItem("loggedInUser")
  );

  const formData = new FormData();

formData.append("tpshop_id", shopId);
formData.append("tporder_id", orderId);
formData.append("tpcustomer_id", savedCustomer.id);
formData.append("rating", rating);
formData.append("review", review);
 
 console.log(shopId, orderId);

  axios
    .post(
      `${baseUrl}/customer/shop/createRating`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      console.log(res.data);

      if (res.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Review Submitted Successfully",
          confirmButtonColor: "#198754",
        }).then(() => {
          navigate(`/shop/${shopId}`);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.message || "Failed to submit review",
        });
      }
    })
    .catch((err) => {
      console.log(err);

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong. Please try again.",
      });
    });
};

  const ratingLabels = {
    1: "Poor 😔",
    2: "Fair 🙂",
    3: "Good 😊",
    4: "Very Good 😍",
    5: "Excellent ⭐",
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);

    const previews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

   
  };

  // const handleSubmit = () => {
  //   console.log({
  //     rating,
  //     review,
  //     images,
  //   });

  //   alert("Review Submitted");
  // };

  const handleCancel = () => {
    setRating(0);
    setReview("");
    
  };
  const handleRating = (star) => {
  if (star === rating) {
    setRating(star - 1);
  } else {
    setRating(star);
  }
};

  return (
    <Container fluid className="rating-page py-4">
      <MarqueeBanner />
           <Navbar />

            <SimpleBanner
                title="Rating"
                subtitle=""
                breadcrumbs={[
                    { label: "Home", href: "/" },
                     { label: "orders", href: "/customer-orders" },
                    { label: "rating", href: "/rate/:id" },
                ]}
            />
      <div className="mb-4 d-flex align-items-start gap-3">
        <FaArrowLeft
          className="back-icon"
          onClick={() => navigate("/customer-orders")}
        />

        <div>
          <h3 className="fw-bold mb-1">
            Rate Your Order
          </h3>

          <p className="text-muted mb-0">
            Share your experience for ORD-005
          </p>
        </div>
      </div>

      <Card className="rating-card border-0 shadow-sm">
        <Card.Body>
          <Row className="align-items-start mb-4">
            <Col xs={8}>
              <h4 className="fw-bold mb-3">
                Glamour Studio
              </h4>

              <div className="d-flex flex-wrap gap-2">
                <span className="service-tag">
                  Hair Color
                </span>

                <span className="service-tag">
                  Cut
                </span>

                <span className="service-tag">
                  Blowdry
                </span>
              </div>
            </Col>

            <Col
              xs={4}
              className="text-end"
            >
              <Badge className="order-badge">
                ORD-005
              </Badge>
            </Col>
          </Row>

          {/* Rating */}

       <Form.Group className="mb-4">
  <Form.Label className="fw-semibold">
    How would you rate it?
  </Form.Label>

<div className="rating-wrapper">
<div className="rating-stars">
  {[1, 2, 3, 4, 5].map((star) => (
    <span
      key={star}
      className={`star-icon ${
        star <= rating ? "active" : ""
      }`}
      onClick={() => handleRating(star)}
    >
      {star <= rating ? <FaStar /> : <FaRegStar />}
    </span>
  ))}
</div>

  <span className="rating-text">
    {rating > 0
      ? `${ratingLabels[rating]} (${rating}/5)`
      : "Select Rating"}
  </span>
</div>

  {/* <div className="rating-text mt-3">
    {rating > 0
      ? `${ratingLabels[rating]} (${rating}/5)`
      : "Select Rating"}
  </div> */}
</Form.Group>
          {/* Review */}

          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold">
              Write a review
            </Form.Label>

         <Form.Control
  as="textarea"
  rows={8}
  value={review}
  onChange={(e) => setReview(e.target.value)}
  placeholder="Tell others what you liked or what could be improved..."
/>
          </Form.Group>

          {/* Upload */}

          {/* <Form.Group className="mb-4">
            <Form.Label
              className="upload-btn"
              htmlFor="uploadImages"
            >
              <FaCamera />
              Add Photos (optional)
            </Form.Label>

            <Form.Control
              id="uploadImages"
              type="file"
              multiple
              hidden
              onChange={handleImageUpload}
            />
          </Form.Group> */}

          {/* {images.length > 0 && (
            <div className="image-preview-container mb-4">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img.preview}
                  alt="preview"
                  className="preview-image"
                />
              ))}
            </div>
          )} */}

          {/* Buttons */}

          <div className="d-flex flex-wrap gap-3">
            <Button
              variant="outline-secondary"
              onClick={handleCancel}
            >
              Cancel
            </Button>

            <Button
              className="submit-btn"
              onClick={handleSubmit}
            >
              Submit Review
            </Button>
          </div>
        </Card.Body>
      </Card>
       <Footer />
    </Container>
  );
};

export default CustomerRating;